export const experienceTranslations = {
  es: {
    section_title: 'Experiencia',
    restoo: {
      position: 'Desarrollador Full Stack',
      tasks: [
        'Desarrollo de nuevas funcionalidades utilizando Laravel con PHP 8, React.js y PostgreSQL.',
        'Uno de mis logros más interesantes es un sistema de business intelligence (Node.js, Typescript) que importa y unifica datos desde diferentes fuentes (archivos .csv y la API del CRM Pipedrive), y la creación de dashboards en Metabase para que los equipos de ventas y soporte dispongan de métricas en tiempo real de reservas, clientes, ventas, soporte, etc.',
        'Encargado de mantener y actualizar la web corporativa.',
        'Trabajo en entorno Docker con arquitectura hexagonal, siguiendo metodologías Agile/Scrum y code reviews.',
        'Testing con Pest para asegurar la calidad.'
      ],
      tools1: ['PHP', 'Laravel', 'PostgreSQL', 'Javascript', 'React.js'],
      tools2: ['Node.js', 'Typescript', 'Docker', 'Testing con Pest', 'Arquitectura hexagonal'],
      company_info: 'Sistema digital de gestión de reservas para restaurantes.',
      period: '2024 - actualidad',
    },
    grability: {
      position: 'Desarrollador Full Stack',
      tasks: [
        'Mantenimiento y mejora del CMS que administraba la app del supermercado de El Corte Inglés e Hipercor, con Laravel, React.js y PostgreSQL.',
        'Generación de informes desde la base de datos.',
        'Migración del front desde Ember JS a React.js.',
        'Supervisión del cambio de catálogo cada dos semanas.',
        'Además fui responsable de analizar discrepancias entre la app y la web, garantizando la coherencia en precios y ofertas.',
      ],
      tools1: ['PHP', 'Laravel', 'PostgreSQL'],
      tools2: ['Javascript', 'React.js', 'Docker'],
      company_info: 'Empresa responsable de la app del supermercado de El Corte Inglés e Hipercor.',
      period: '2021 - 2024',
    },
    gestinet: {
      position: 'Estudiante en prácticas',
      tasks: [
        'Colaboré en proyectos para clientes de distintos sectores, desarrollando y adaptando sitios web.',
      ],
      tools1: ['WordPress', 'PHP'],
      tools2: ['JavaScript', 'CSS'],
      company_info: 'Cosultoria Tecnològica.',
      period: '2020 (4 meses)',
    },
    clicko: {
      position: 'Estudiante en prácticas',
      tasks: [
        'Colaboré en proyectos para clientes de distintos sectores, desarrollando y adaptando sitios web.',
      ],
      tools1: ['PHP', 'Laravel'],
      tools2: ['Javascript', 'CSS'],
      company_info: 'Cosultoria Tecnològica.',
      period: '2019 (1 mes)',
    },
    binary_sunset: {
      position: 'Técnico de sonido',
      tasks: [
        'Grabación, mezcla y mastering.',
      ],
      company_info: 'Estudio de grabación',
      period: '2013 - 2020',
    },
  },
  en: {
    section_title: 'Experience',
    grability: {
      position: 'Full Stack Developer',
      company_info: 'Company responsible for the supermarket app of El Corte Inglés and Hipercor. Maintenance and improvement of the CMS...'
    },
    gestinet: {
      position: 'Intern',
      company_info: 'Mainly Wordpress, Javascript, CSS, PHP.'
    },
  },
};
